<template>
    <div class="color-card-wrapper" :class="[size, { selected: selected, interactive: interactive }]">
        <div v-if="name !== 'empty'" class="color" :style="`--color: ${color}`"></div>
        <div v-else class="empty">
            <span>Geen kleur</span>
        </div>
        <div v-if="name !== 'empty'" class="content">
            <span class="name">{{ name }}</span>
            <span class="color-code">{{ color }}</span>
        </div>
        <q-icon class="check-icon" type="check" :color="name !== 'empty' ? 'white' : '#00A1AE'"></q-icon>
        <q-options v-if="options.length > 0 && name !== 'empty'" :options="options" color="#C4C4C4" class="color-options" @input="handleOptionSelected"></q-options>
    </div>
</template>

<script>
export default {
    name: 'q-color-card',
    props: {
        color: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'medium',
            validator: value => {
                return value.match(/(small|medium)/);
            }
        },
        interactive: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default() { return [] }
        }
    },
    methods: {
        handleOptionSelected(option) {
            this.$emit('optionSelected', option)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/qds/assets/style/_variables.scss';

.color-card-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 2px rgba(128, 128, 128, 0.15);
    border-radius: 6px;
    width: 100%;
    transition: scale .2s cubic-bezier(.45,1.8,.58,1.21), outline .15s ease;
    isolation: isolate;
    user-select: none;
    background-color: white;

    &.small {
        height: 64px;
        width: 130px;

        .content {
            padding: 5px 8px;
        }

        .color-options {
            right: 2px;
            bottom: 6px;
        }
    }

    &.medium {
        height: 100px;
        width: 150px;

        .content {
            padding: 8px 10px;
        }

        .color-options {
            right: 4px;
            bottom: 10px;
        }
    }

    // interactions
    &.interactive {
        cursor: pointer;

        &:active {
            scale: 0.97 !important;
            z-index: 1;
        }

        &:hover {
            scale: 1.02;
            z-index: 1;
        }
    }

    &.selected {
        outline: 2px solid #00A1AE;

        .check-icon {
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
        }
    }

    .color {
        height: 100%;
        width: 100%;
        background-color: var(--color, #ffffff);
        border-radius: 6px 6px 0 0;
    }

    .empty {
        display: grid;
        place-items: center;
        height: 100%;

        span {
            font-size: 14px;
            font-weight: 500;
            color: $color-grey-5;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        border-radius: 0 0 6px 6px;

        > span {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .name {
            color: #484f56;
            font-weight: 500;
            font-size: 11px;
            line-height: 13px;
        }
        .color-code {
            color: #C4C4C4;
            font-size: 10px;
            line-height: 12px;
        }
    }

    .check-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        clip-path: polygon(0 0, 0 0, 0 100%, 0% 100%);
        transition: clip-path .3s ease;
    }

    .color-options {
        position: absolute;
    }
}
</style>